import { render, staticRenderFns } from "./HelpAnswerModal.vue?vue&type=template&id=26a5d464&scoped=true"
import script from "./HelpAnswerModal.vue?vue&type=script&lang=js"
export * from "./HelpAnswerModal.vue?vue&type=script&lang=js"
import style0 from "./HelpAnswerModal.vue?vue&type=style&index=0&id=26a5d464&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5d464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a5d464')) {
      api.createRecord('26a5d464', component.options)
    } else {
      api.reload('26a5d464', component.options)
    }
    module.hot.accept("./HelpAnswerModal.vue?vue&type=template&id=26a5d464&scoped=true", function () {
      api.rerender('26a5d464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/HelpAnswerModal.vue"
export default component.exports